// extracted by mini-css-extract-plugin
export var numpadContainer = "_o3-1";
export var phoneButton = "_o3-0";